import React from 'react';
import { Typography } from 'antd';
import styled from '@emotion/styled';
import { useSize } from 'ahooks';

const Wrapper = styled.div`
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(225, 228, 235, 1);
  border-radius: 3px;
  box-shadow: 0 2px 12px 0 rgba(192, 195, 204, 0.15);
  padding: 20px;
  display: flex;
  height: 230px;
`;
const Left = styled.div`
  width: 62px;
  min-width: 62px;
  height: 62px;
  flex: 0 1 62px;
  > img {
    width: 62px;
    height: auto;
  }
`;

const Right = styled.div`
  display: flex;
  flex: 1;
  margin-left: 16px;
  flex-direction: column;
  flex-basis: 100%;
  overflow: hidden;
`;
const Title = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 4px;
`;
const Tag = styled.span`
  display: inline-block;
  height: 24px;
  padding: 2px 8px;
  line-height: 1.4em;
  text-align: center;
  border: 1px solid #b5b9bf;
  font-size: 12px;
  border-radius: 2px;
  align-self: center;
  color: #515359;
`;
const Description = styled(Typography.Paragraph)`
  font-size: 14px;
  color: #515359;
  line-height: 22px;
  margin-bottom: 24px;
  word-break: break-all;
  flex: 1 1 auto;
`;
const Footer = styled.div`
  display: flex;
  flex-basis: 100%;
  align-items: end;
  flex: 0 1 32px;
`;
export interface AppConfig {
  name: React.ReactNode;
  desc: React.ReactNode;
  icon: string | React.ReactNode;
  status?: 'enabled' | 'disabled';
}

export interface CommonAppCardProps extends AppConfig {
  className?: string;
  footer?: React.ReactNode;
}

const CommonAppCard = (props: CommonAppCardProps) => {
  const { className, footer, name, desc, icon, status } = props;
  // eslint-disable-next-line jsx-a11y/alt-text
  const iconComp = typeof icon === 'string' ? <img src={icon} /> : icon;
  const RIGHT_HEIGHT = 188;
  const BUTTON_HEIGHT = 32;
  const CONTENT_HEIGHT = RIGHT_HEIGHT - BUTTON_HEIGHT;
  const ref = React.useRef<HTMLDivElement>(null);
  const TITLE_HEIGHT = useSize(ref)?.height || 0;
  const RETAIN_HEIGHT = CONTENT_HEIGHT - TITLE_HEIGHT;
  const rows = Math.floor(RETAIN_HEIGHT / 22);

  return (
    <Wrapper className={className}>
      <Left>{iconComp}</Left>
      <Right>
        <Title ref={ref}>
          {name}
          {status ? <Tag>{status === 'disabled' ? '未启用' : '已启用'}</Tag> : null}
        </Title>
        <Description ellipsis={{ tooltip: true, rows }}>{desc}</Description>
        <Footer>{footer}</Footer>
      </Right>
    </Wrapper>
  );
};
export default React.memo(CommonAppCard);
